import React from "react";
import PropTypes from "prop-types";

import SingleComment from "./SingleComment";

function CommentList({comments}) {
    return (
        <div>
            {comments.map((comment, index) => {
                let name, person, greyBackground;
                if (comment.profile && comment.profile.person) {
                    person = comment.profile.person;
                    name =
                        person.nickname ?
                            `${person.first_name} (${person.nickname}) ${person.last_name}` :
                            `${person.first_name} ${person.last_name}`;
                } else if (comment.guest_name) {
                    name = comment.guest_name;
                } else {
                    name = 'Guest';
                }

                greyBackground = index % 2 !== 0;

                // Loads the current Comment and recursively loads another CommentList if it has children
                return (
                    <SingleComment
                        key={comment.id}
                        name={name}
                        comment={comment.text}
                        timestamp={comment.created_at}
                        greyBackground={greyBackground}
                    >
                        {comment.tree.length > 0 &&
                        <CommentList
                            comments={comment.tree}
                        />
                        }
                    </SingleComment>
                )
            })}
        </div>
    )
}

CommentList.propTypes = {
    comments: PropTypes.array.isRequired,
};

export default CommentList;
